import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ResultHelper } from '../../../httpClient/utils/ResultHelper';
import WebHttpClient from '../../../httpClient/WebHttpClient';
import { IDetailFetcher } from '../../../ts/fetchers/IDetailFetcher';
import { GetDetailRequest } from '../../../ts/ServerApi/requests/GetDetailRequest';

export class WebClientDetailFetcher<TResource, TRequestResult> implements IDetailFetcher<TResource> {

  constructor(
    private requestMethod: string,
    private resultMapper: (result: TRequestResult) => TResource
  ) { }

  public fetchById(id: string): Promise<TResource> {
    return WebHttpClient.sendRequest(new GetDetailRequest<TRequestResult>(this.requestMethod, id))
      .then(ResultHelper.rejectResultOnError())
      .then<TResource>(
        (result: TRequestResult) => Promise.resolve(this.resultMapper(result)),
        (result: IResult) => Promise.reject(result.errors && result.errors[0] && result.errors[0].code)
      );
  }

}
